<template>
  <div>
    <h3>
      Métodos de pagamento
    </h3>
    <PaymentMethodConfigList :subjectPermission="subjectPermission"/>
  </div>
</template>
<script lang="ts">
import PaymentMethodConfigList from './components/PaymentMethodConfigList.vue';
export default {
  name: 'PaymentMethodConfig',
  components: {PaymentMethodConfigList},
  props: ['subjectPermission'],
};

</script>
